// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { systemBuilderTypeStyles } from "@plumberssupply/App/Components/SystemBuilder/SystemBuilderType";
import { color, xScreen } from "@plumberssupply/XDL/Utilities";
import { css } from "styled-components";

systemBuilderTypeStyles.wrapper = {
    css: css`
        border: 1px solid ${color("common.ui7")};
        padding: 12px;
        display: flex;
        column-gap: 12px;
        width: 418px;
        ${xScreen("lte", "md")} {
            width: calc(50% - 11px);
        }
        ${xScreen("lte", 767)} {
            width: 100%;
        }
    `,
};
systemBuilderTypeStyles.infoWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 12px;
    `,
};
systemBuilderTypeStyles.description = {
    size: 14,
    lineHeight: "22px",
};
systemBuilderTypeStyles.imageWrapper = {
    css: css`
        min-width: 56px;
        width: 56px;
    `,
};
systemBuilderTypeStyles.image = {
    css: css`
        height: auto;
        img {
            width: auto;
            height: auto;
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
        }
    `,
};
systemBuilderTypeStyles.button = {
    css: css`
        margin-top: 4px;
    `,
};
systemBuilderTypeStyles.title = {
    variant: "h3",
    forwardAs: "p",
    css: css`
        margin-bottom: 0;
    `,
};
systemBuilderTypeStyles.buttonWrapper = {
    css: css`
        margin-top: auto;
    `,
};
